<div class="settings-chart">
  <div class="setting-row">
    <span class="setting-label">All Actions</span>
    <div class="setting-controls">
      <div class="channel">
        <mat-checkbox
          [checked]="masterNotificationState.checked"
          [indeterminate]="masterNotificationState.indeterminate"
          (change)="onMasterNotificationChange($event.checked)">
          <span class="channel-label">Notification</span>
        </mat-checkbox>
      </div>
      <div class="channel">
        <mat-checkbox
          [checked]="masterEmailState.checked"
          [indeterminate]="masterEmailState.indeterminate"
          (change)="onMasterEmailChange($event.checked)">
          <span class="channel-label">Email</span>
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div class="setting-row">
    <span class="setting-label">At mention in notes</span>
    <div class="setting-controls">
      <div class="channel">
        <mat-checkbox 
          [(ngModel)]="settingsState.atMention.notification" 
          (change)="onSettingChange()">
        </mat-checkbox>
      </div>
      <div class="channel">
        <mat-checkbox 
          [(ngModel)]="settingsState.atMention.email" 
          (change)="onSettingChange()">
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div class="setting-row">
    <span class="setting-label">Assignee changes to you</span>
    <div class="setting-controls">
      <div class="channel">
        <mat-checkbox 
          [(ngModel)]="settingsState.assigneeChanges.notification" 
          (change)="onSettingChange()">
        </mat-checkbox>
      </div>
      <div class="channel">
        <mat-checkbox 
          [(ngModel)]="settingsState.assigneeChanges.email" 
          (change)="onSettingChange()">
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div class="setting-row">
    <span class="setting-label">Status change on intervention assigned to you</span>
    <div class="setting-controls">
      <div class="channel">
        <mat-checkbox 
          [(ngModel)]="settingsState.statusChange.notification" 
          (change)="onSettingChange()">
        </mat-checkbox>
      </div>
      <div class="channel">
        <mat-checkbox 
          [(ngModel)]="settingsState.statusChange.email" 
          (change)="onSettingChange()">
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>

<div class="settings-footer">
  <button mat-flat-button color="primary" class="save-btn" (click)="saveSettings()">
    <mat-icon>check_circle</mat-icon>
    <span>Save</span>
  </button>
</div>
